import { Injectable, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { AppState } from '@state/app.state';
import { Store } from '@ngrx/store';
import { logout } from '@state/auth/auth.actions';

@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService implements OnDestroy {
  private idleTime: number = environment.IDLE_TIMEOUT;
  private checkInterval = 1000;
  private intervalSub?: Subscription;
  private lastActivity = Date.now();

  constructor(
    private authService: AuthService,
    private store: Store<AppState>
  ) {
    this.initListeners();
    this.startMonitoring();

    window.addEventListener('storage', event => {
      if (event.key === 'lastActivity') {
        this.resetLocalTimer();
      }
    });
  }

  private initListeners(): void {
    ['mousemove', 'keydown', 'mousedown', 'touchstart'].forEach(event => {
      document.addEventListener(event, this.updateLastActivity);
    });
  }

  private updateLastActivity = () => {
    const now = Date.now();
    localStorage.setItem('lastActivity', now.toString());
    this.lastActivity = now;
  };

  private resetLocalTimer(): void {
    const stored = Number(localStorage.getItem('lastActivity'));
    if (!isNaN(stored)) {
      this.lastActivity = stored;
    }
  }

  private startMonitoring(): void {
    this.updateLastActivity();

    this.intervalSub = interval(this.checkInterval).subscribe(() => {
      const now = Date.now();
      const diff = now - this.lastActivity;

      if (diff >= this.idleTime) {
        const token = this.authService.getLocalToken();
        if (token) {
          this.store.dispatch(logout({ token }));
        }
      }
    });
  }

  public stayLoggedIn(): void {
    this.updateLastActivity();
  }

  ngOnDestroy(): void {
    this.intervalSub?.unsubscribe();
    ['mousemove', 'keydown', 'mousedown', 'touchstart'].forEach(event => {
      document.removeEventListener(event, this.updateLastActivity);
    });
  }
}
